import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './../index.less'
import i18n from "./i18n";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import './utils/directives'

Vue.use(ElementUI, {
  // 在注册Element时设置i18n的处理方法,可以实现当点击切换按钮后，elementUI可以自动调用.js语言文件实现多语言切换
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
